import React from "react";
import ChevronRight from "../icons/heroicons/solid/ChevronRight";

const DangerButton = ({
  disabled = false,
  buttonName = "เข้าสู่ระบบ",
  htmlType = "submit",
  seniorLayout = false,
  onClick,
}) => {
  return (
    <button
      //   className={`w-full h-full font-semibold relative rounded-lg bg-red-600 text-white flex items-center justify-between px-4 py-2 ${
      //     seniorLayout ? "text-xl" : "text-lg"
      //   }
      // ${disabled ? "opacity-50 cursor-not-allowed" : "hover:bg-red-700"}`}
      className={`w-full  h-full font-semibold relative bg-red-600 text-white flex items-center justify-between py-3 px-8 text-xl hover:bg-red-700 rounded-[5rem] p-20
      ${seniorLayout ? "text-xl" : "text-lg"}`}
      type={htmlType}
      disabled={disabled}
      onClick={(event) => {
        if (htmlType !== "submit") {
          event.preventDefault();
        }
        onClick && onClick(event);
      }}
    >
      <div className="w-full whitespace-nowrap text-center">{buttonName}</div>
      <ChevronRight className="w-8" />
    </button>
  );
};

export default DangerButton;
